var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.addDeposit)?_c('div',[_c('input',{staticClass:"deposit",attrs:{"type":"hidden","id":_vm.id,"name":_vm.name}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }